import React from "react";

const APIDocs = () => {
  return <h1>API Docs Page</h1>;
};

export default APIDocs;